export function SkipLink() {
  return (
    <a
      href="#main"
      className="focus:bg-primary-container focus:font-body focus:text-label-sm focus:text-on-primary-container sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[60] focus:rounded-md focus:px-4 focus:py-2"
    >
      Skip to content
    </a>
  )
}
